import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${({ device }) => (device === 'desktop' ? '24.2px' : '16px')};
  align-items: start;
  justify-content: flex-start;
  .containerCta {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${select('blue')};
    font-family: Hind;
    font-style: normal;
    font-size: 14px;
    font-weight: 600;
    line-height: 130%;
    margin-left: 8px;
    > button {
      cursor: pointer;
    }
  }
`;

const CardContainer = styled.div`
  width: 100%;
  min-height: 112px;
  min-width: ${({ device }) => (device === 'desktop' ? '510px' : 'unset')};
  border: 1.275px solid ${select('midDarkGray')};
  border-radius: 10.2px;
  display: flex;
  align-items: center;
  gap: 20.4px;
  margin-top: ${({ device }) => (device === 'desktop' ? '6.8px' : '0px')};
  .imageContainer {
    width: 163.2px;
    height: 100%;
    display: flex;
    align-items: start;
    padding-top: 20.4px;
    padding-left: 20.4px;
  }
  .infoContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-family: Hind;
    font-style: normal;
    padding-top: 20.4px;
    padding-bottom: 15px;
    overflow: hidden;
    .name {
      font-size: ${({ device }) => (device === 'desktop' ? '16px' : '13.12px')};
      font-weight: 400;
      line-height: normal;
      color: ${select('midDarkGray')};
      text-overflow: ellipsis;
      overflow: hidden;
      margin-right: 14px;
    }
  }
`;

const PhoneContainer = styled.div`
  font-size: ${({ device }) => (device === 'desktop' ? '16px' : '16.4px')};
  font-weight: 600;
  line-height: 130%;
  display: flex;
  gap: ${({ getDirection, device }) => (getDirection && device === 'desktop' ? '18px' : '4px')};
  flex-direction: ${({ getDirection, device }) => (getDirection && device === 'desktop' ? 'row' : 'column')};
  ${({ getDirection, device }) =>
    getDirection && device === 'desktop'
      ? css`
          :last-child {
            margin-right: 14px;
          }
        `
      : css`
          margin-right: 14px;
        `}
  .tel {
    display: flex;
    gap: 18px;
  }
  .separator {
    height: 7px;
    width: 7px;
    background-color: ${select('black')};
    border-radius: 50%;
    margin-top: 11px;
  }
`;

const PhoneStyled = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: ${({ device }) => {
    if (device === 'mobile') return '85.28px';
    if (device === 'tablet') return '92.56px';
    return '132.6px';
  }};
  height: ${({ device }) => {
    if (device === 'mobile') return '45.92px';
    if (device === 'tablet') return '45.92px';
    return '71.4px';
  }};
  position: relative;
`;

const TagPremier = styled.img`
  height: 20.4px;
  width: 20.4px;
  position: absolute;
  top: -6px;
  right: -6px;
`;

export { Container, CardContainer, Img, TagPremier, PhoneContainer, PhoneStyled };
